import $ from 'jquery';
import MenuItem from 'material-ui/MenuItem';
import SelectField from 'material-ui/SelectField';
import React, { Component } from 'react';
import { connect } from "react-redux";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import * as actions from '../../actions/actions.jsx';
import service from '../../services/allservices.jsx';
import '../../stylesheet/faqs.css';
import AuthNavbar from '../navigation/authnavigation.jsx'
import { getClientId, getClientSecret, buildClientHeader } from '../../utils/clientAuth.js';


const mapStateToProps = state =>
({
    publicKey: state.publicKey.publicKey,
    keyRecieved: state.publicKey.keyRecieved,
    cardState: state.getCardReducer.cardState,
    display: state.getCardReducer.display
})

const mapDispatchToProps = dispatch =>
({
    fetchCard(state) {
        dispatch(
            actions.getCardAction(state)
        )
    },
    fetchPublicKey(keyRecieved) {
        dispatch(
            actions.publicKeyAction(keyRecieved)
        )
    },
})

class WalletFaq extends Component {
    constructor(props) {
        super(props)
        this.state = {
            ViewQnA: [],
            toggleType: "password",
            toggleText: "password",
            toggleIcon: "fa fa-eye-slash",
            togglePassIcon: "fa fa-eye-slash",
            open: true,
            viewStatus: null,
            loader: true,
        }
    }
    async componentDidMount() {

        $('.panel-collapse').on('show.bs.collapse', function () {
            $(this).siblings('.panel-heading').addClass('active');
        });

        $('.panel-collapse').on('hide.bs.collapse', function () {
            $(this).siblings('.panel-heading').removeClass('active');
        });
        const JSEncrypt = window.JSEncrypt
        const { publicKey } = this.props
        if (publicKey.status === 200) {
            const public_Key = publicKey.body.publickey;
            let encrypt = new JSEncrypt();
            encrypt.setPublicKey(public_Key);

            const state = {
                applicationId: localStorage.getItem('pform') === 'AU' ? 'klickexau' : 'klickex',
                accountId: encrypt.encrypt(localStorage.getItem("accountId"))
            }
            this.props.fetchCard(state)
        }
   
        this.setState({
            selectedCard: this.props.cardState.body,
        }, () => {

            if (!this.state.selectedCard || this.state.selectedCard.length === 0) return;

            let plink = localStorage.getItem('pform') === 'AU' ? process.env.REACT_APP_SERVICEURL_AU : process.env.REACT_APP_SERVICEURL_NZ
            let traceId = getClientId();
            let gid = getClientId();
            fetch(plink + service.ViewWalletFAQ + "/" + this.state.selectedCard[0].programId, {
                headers: new Headers({
                    'Content-Type': 'application/json',
                    'X-Trace-Id': traceId,
                    'clientId': gid,
                    'clientSecret': getClientSecret(gid, this.state.selectedCard[0].programId),
                    'X-Client-APP': buildClientHeader(),
                }),
            })
                .then(response => {
                    if (response.status === 200) {
                        response.json().then(json => {
                            this.setState({
                                ViewQnA: json,
                                viewStatus: 200,
                            });
                        });
                    }
                    else if (response.status === 422) {
                        toast.error(response.headers.get('message'));
                    }
                    else if (response.status === 401) {
                        if (this.props.history !== undefined) {
                            this.props.history.push('/SessionOut');
                        }
                    }
                });
        });

       
    }
    render() {
        const { ViewQnA, selectedCard, cardDetailsId } = this.state
        const { cardState } = this.props
        console.log("Selected Card ", selectedCard)
        return (
            <div>
                <div className="row" >
                    <div className="col-sm-12">
                        <AuthNavbar />
                    </div>
                    <div className="container" style={{}}>
                        <div className="row">
                            {/* <div className="col-sm-3 box-shadow-style nopadding" style={{ minHeight: "470px" }}>
                                    <LeftLink />
                                </div> */}
                            <div className="col-sm-12">
                                <div className="row" style={{ padding: "12px 0px", minHeight: "476px" }}>


                                    <div className="col-sm-12 ml-2" style={{}}>
                                        <div className="header-style" style={{ padding: "5px 20px 0px 15px" }}>
                                            <h4 className='logmainheading mainheading'>
                                                FAQs
                                            </h4>
                                        </div>

                                        <div className="col-sm-12 p-0 accordion animated zoomIn" id="accordionExample" style={{ background: "#fff", width: "98%" }}>
                                            <div className="row">
                                                <div className="col-sm-12 ">
                                                    {ViewQnA && ViewQnA.map((value, Index) =>
                                                        <div className="col-sm-12">

                                                            <div className="faq-questions " >
                                                                <div className="collapsed" data-toggle="collapse" data-target={`#collapseExample${Index + 1}`} aria-expanded="true" aria-controls="collapse">
                                                                    <i className="fa fa-plus-circle faqswitch" style={{ float: "left", marginRight: "5px", }} aria-hidden="true"></i>
                                                                    {value.question}
                                                                </div>

                                                            </div>
                                                            <div className="faq-answer collapse" id={`collapseExample${Index + 1}`} aria-labelledby="headingOne" data-parent="#accordionExample">
                                                                <div dangerouslySetInnerHTML={{ __html: value.answer }}></div>
                                                            </div>
                                                            <hr />
                                                        </div>
                                                    )
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(WalletFaq);


// WEBPACK FOOTER //
// ./src/components/wallet/walletfaq.jsx